import React, { useCallback } from 'react';

import { MODIFY_TICKET } from '../../../common/graphql/ticket';
import { List } from '../../components';
import { ListContainer } from '../../containers';
import TicketListItem from '../ticket/TicketListItem';

const TicketListRaw = ({
	items,
	modifyItem,
	showMachineName,
	onTicketResolved,
	trainingContext,
	serviceDocketId,
}) => (
	<List
		listItemComponent={TicketListItem}
		items={items}
		customProps={{
			modifyItem,
			showMachineName,
			isTicketList: true,
			onTicketResolved,
			trainingContext,
			serviceDocketId,
		}}
	/>
);

const TicketList = ListContainer(TicketListRaw);

const TicketListView = ({
	items,
	showMachineName,
	onAfterResolve,
	trainingContext,
	serviceDocketId,
}) => {
	const handleTicketResolved = useCallback(() => {
		if (onAfterResolve) {
			onAfterResolve();
		}
	}, [onAfterResolve]);

	return (
		<TicketList
			modifyMutation={MODIFY_TICKET}
			frontEnd={true}
			items={items}
			showMachineName={showMachineName}
			onTicketResolved={handleTicketResolved}
			trainingContext={trainingContext}
			serviceDocketId={serviceDocketId}
		/>
	);
};

export default TicketListView;
